import React from 'react';
import { useIntl } from 'react-intl';

import StarsLink from '@swf/components/StarsLink/StarsLink';
import Translation from '@swf/components/Translation/Translation';
import { ResolverTag } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';

import {
  TXTINT_BRAND_PokerStars,
  TXTWCL_Download_XXPokerBrandXX_Client,
  TXTWCL_If_you_would_like_to_play_this_ELL,
  TXTWCL_SorryX_this_game_is_not_availa_ELL
} from './Unsupported.messages.json';
import styles from './Unsupported.scss';

const Unsupported = () => {
  const { formatMessage } = useIntl();
  return (
    <div className={styles.container}>
      <p className={styles.big}>
        ⚠️ <Translation {...TXTWCL_SorryX_this_game_is_not_availa_ELL} />
      </p>
      <p className={styles.small}>
        <Translation {...TXTWCL_If_you_would_like_to_play_this_ELL} />
      </p>
      <StarsLink
        className={styles.link}
        target="_blank"
        rel="noopener noreferrer"
        href={useResolver(ResolverTag.PSDownload)}
      >
        <Translation
          {...TXTWCL_Download_XXPokerBrandXX_Client}
          values={{ pokerBrand: formatMessage(TXTINT_BRAND_PokerStars) }}
        />
      </StarsLink>
    </div>
  );
};
export default Unsupported;
